import { render, staticRenderFns } from "./MonitorMilestoneComments.vue?vue&type=template&id=34ff4eb6&"
import script from "./MonitorMilestoneComments.vue?vue&type=script&lang=js&"
export * from "./MonitorMilestoneComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports